import {AbstractController} from "../../../controllers/AbstractController";
import {IT_SUB_TITLE, IViewSubTitleController, MK_VIEW_SUB_TITLE} from "./IViewSubTitleController";
import {inject, Injectable, signal} from "@angular/core";
import {ControllerEventBus} from "../../../event-buses/controller.event-bus";
import {ControllerEventName} from "../../../event-buses/ControllerEventName";
import {ControllerEvent} from "../../../event-buses/ControllerEvent";

@Injectable()
export class ViewSubTitleController extends AbstractController implements IViewSubTitleController {

  constructor(controllerEventBus: ControllerEventBus) {
    super(controllerEventBus);

    const subTitle = inject(IT_SUB_TITLE, {optional: true});

    this.addModel(MK_VIEW_SUB_TITLE, {
      subTitle$: signal(subTitle || 'No sub-title provided'),
    });

    this.sub(this.eventBus().subscribe(ControllerEventName.UpdateSubTitle, (event) => {
      this.onUpdateSubTitle(event);
    }));
  }

  onUpdateSubTitle(controllerEvent: ControllerEvent): void {
    const subTitle: string = controllerEvent.eventData['subTitle'];

    this.getModel(MK_VIEW_SUB_TITLE).subTitle$.set(subTitle);
  }
}
